// extracted by mini-css-extract-plugin
module.exports = {"alt-sidebar":"AltSidebar_alt-sidebar__OrMEe"};